export default {
  namespaced: true,
  state: {
    dataList: [
      // {
      //   name: "深刻的海内外材料有限公司介绍深刻的海内外材料有限公司介绍",
      //   text: "爱好就是改变渡鸦三年后大屿山改变对俺说合适的不牙疼不是病大概估算是个爱好就是改变渡鸦三年后大屿山改变对俺说合适的不牙疼不是病大概估算是个",
      //   time: "2023-04-25",
      // },
    ]
  }
}
